import { useEffect } from 'react'

import { useAtom, useSetAtom } from 'jotai'

import { getArrayItemIdFromFieldPath } from 'Automations/nodeDefinitions/validation/helpers'
import {
  focusedSwitchGroupAtom,
  selectedNodeFieldAtom
} from 'Automations/automationEditor/atoms'
import { useNode } from '../../../../hooks'
import { Config } from '../..'
import { selectedGroupIdAtom } from '../../switch.atoms'

export const useNodeFieldGroupSync = (nodeId: string) => {
  const { nodeData } = useNode<Config>({ nodeId })
  const setSelectedGroupId = useSetAtom(selectedGroupIdAtom)
  const setFocusedSwitchGroup = useSetAtom(focusedSwitchGroupAtom)
  const [selectedField, setSelectedField] = useAtom(selectedNodeFieldAtom)

  useEffect(() => {
    if (!selectedField || selectedField.nodeId !== nodeId) return

    const groupId = getArrayItemIdFromFieldPath(selectedField.fieldId, 'groups')
    const isValidGroup = nodeData?.groups.some(({ id }) => id === groupId)
    if (groupId && isValidGroup) {
      setSelectedGroupId(groupId)
    }
    if (groupId) {
      setFocusedSwitchGroup(groupId)
    }
    setSelectedField(undefined)
  }, [
    selectedField,
    nodeId,
    nodeData?.groups,
    setSelectedGroupId,
    setFocusedSwitchGroup,
    setSelectedField
  ])
}
